import {EventEmitter, Injectable}   from "@angular/core";
import { UtilitesService } from "../../base-module/base-service/utilites.service";
import { AuthService } from "../../base-module/base-service/auth.service";
import { Observable } from "rxjs";
import {HttpClient} from "@angular/common/http";

@Injectable()
export class ClienteCustoService {

    public empresaPadrao = new EventEmitter<any>();

    constructor(private authService: AuthService,
                private _http: HttpClient,
                public utilitesService: UtilitesService) {
    }

    /**
     * Cliente custos por id
     * @param id ID da Cliente custos
     */
    getById(id: number): Observable<any> {
        return this._http.get(this.utilitesService.urlPrefix + "custos-clientes/" + id, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Lista de Cliente custos
     * @param id ID da Cliente custos
     */
    getAll(params: any): Observable<any> {

        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if(paramHttp != null && paramHttp != ""){
            env = "?"+paramHttp;
        }

        return this._http.get(this.utilitesService.urlPrefix + "custos-clientes"+env, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Lista de Cliente custos
     * @param id ID da Cliente custos
     */
    search(params: any): Observable<any> {

        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if(paramHttp != null && paramHttp != ""){
            env = "?"+paramHttp;
        }

        return this._http.get(this.utilitesService.urlPrefix + "custos-clientes"+env, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Delete de Cliente custos
     * @param id ID da Cliente custos
     */
    delete(id: number): Observable<any> {
        return this._http.delete(this.utilitesService.urlPrefix + "custos-clientes/"+id, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Cadastra Cliente custos
     * @param params Json Cliente custos
     */
    create(params: any):Observable<any>{
        return this._http.post(this.utilitesService.urlPrefix + "custos-clientes", JSON.stringify(params), { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Atualiza Cliente custos
     * @param params Json Cliente custos
     */
    update(id: number, params: any):Observable<any>{
        return this._http.put(this.utilitesService.urlPrefix + "custos-clientes/"+id, JSON.stringify(params), { headers: this.authService.getAuthHeaders() });
    }

}
